import React from 'react'
import { createRoot } from 'react-dom/client'
import { LodgeFinder } from '../components/pages/LodgeFinder'
import { MotionProvider } from '../lib/motionProvider'

const mountApp = () => {
  const rootEl = document.getElementById('lodge-finder-root')
  if (!rootEl) return

  if (rootEl.dataset.mounted === 'true') return
  rootEl.dataset.mounted = 'true'

  const props = JSON.parse(rootEl.dataset.props || '{}')

  const root = createRoot(rootEl)
  root.render(
    <MotionProvider>
      <LodgeFinder {...props} />
    </MotionProvider>,
  )
}

document.addEventListener('turbo:load', mountApp)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountApp)
} else {
  mountApp()
}
